import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from '../../utils';

export const ProtectedRoute = ({ component: Component, auth, ...rest }) => {
  const runderCondition = props => {
    if (getToken() !== null || auth === true) {
      return <Component {...props} />;
    }
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    );
  };

  return <Route {...rest} render={props => runderCondition(props)} />;
};



// WEBPACK FOOTER //
// ./src/views/FullContainer/protected-routes.js